import lazySizes from "lazysizes";
import bootstrap from "bootstrap";
import gsap from "gsap/dist/gsap";
import AOS from "aos";

import "aos/dist/aos.css";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import fonts from "../modules/fonts";
import headerAnimations from "../modules/headerAnimations";
import doubleCta from "../modules/doubleCta";
import carousels from "../modules/elements/carousels";
import menus from "../modules/elements/menus";
import blockAnimations from "../modules/elements/blockAnimations";
import timeline from "../modules/elements/timeline";
import resources from "../modules/resources";
import general from "../modules/general";
import matchHeight from "../modules/matchHeight";
import scroll from "../modules/smoothScroll";
import team from "../modules/team";
import { CimplifiCustomGraphic } from "../modules/Animations";
import overlayPopup from "../modules/overlayPopup";
// Setting Up Media Queries for all the responsive images.
lazySizes.cfg.customMedia = {
  "--small": "(max-width: 320px)",
  "--medium": "(min-width: 321px) and (max-width: 768px)",
  "--large": "(min-width: 769px) and (max-width: 1024px)",
};

export default {
  init() {
    AOS.init({
      startEvent: 'load',
    });
    scroll.init();
    fonts.init();
    menus.init();
    carousels.init();
    doubleCta.init();
    timeline.init();
    resources.init();
    matchHeight.init();
    team.init();
    general.init();
    overlayPopup.init();
    
    // All animations
    CimplifiCustomGraphic();
  },
  finalize() {},
};
